import styles from "./Infografica.module.css";

const Infografica = ()=>{
    const clickableBoxes = [
        {
            id: 0,
            style: {
                "width": "18%",
                "height": "4%",
                "left": "69%",
                "top": "12%",
            },
            link: "./assets/video/IAB_Teaser.mp4"
        },
        {
            id: 1,
            style: {
                "width": "41%",
                "height": "2.9%",
                "left": "46%",
                "top": "45.5%"
            },
            link: "./scorm_swot/story.html"
        },
        {
            id: 2,
            style: {
                "width": "41%",
                "height": "2.9%",
                "left": "46%",
                "top": "48.9%"
            },
            link: "./scorm_corso/_corso/index.html"
        },
        {
            id: 3,
            style: {
                "width": "68%",
                "height": "3.2%",
                "left": "18%",
                "top": "73.7%",
            },
            link: "./assets/video/Video_Infografica_CTV.mp4"
        },
        {
            id: 4,
            style: {
                "width": "32%",
                "height": "3.2%",
                "left": "12%",
                "top": "80%"
            },
            link: "./docs/IABItalia_DefinizioneetassonomiaCTV.pdf"
        },
        {
            id: 5,
            style: {
                "width": "32%",
                "height": "3.2%",
                "left": "58%",
                "top": "80%"
            },
            link: "./docs/IABItalia_WhitePaperCTV.pdf"
        }
    ]

    const onOpenLinkHandler = (link)=>{
        window.open(link, "_blank");
    }
    return (
        <div className={styles.Infografica}>
            {clickableBoxes.map(box => <div key={box.id} className={styles.clickableBox} style={box.style} onClick={()=>onOpenLinkHandler(box.link)}></div>)}
            <img src={"./infografica.jpg"} alt=""/>
        </div>
    )
}

export default Infografica;